import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import PopSelect from '@/components/pop-select';
import { rqtPostEquityInvestmentList } from '@/services/cms/customer';
import { rqtPostFloatProductListForSelect } from '@/services/wms/product';
export default {
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt,
    PopSelect
  },
  data() {
    return {
      btnLoading: false,
      searchForm: {
        chnName: undefined,
        isSurvivingShare: "Y",
        productId: null
      },
      listRequest: rqtPostEquityInvestmentList,
      showPopup: false,
      searchItems: [{
        title: '产品',
        type: 'dropdown',
        name: 'productId',
        request: rqtPostFloatProductListForSelect,
        keyName: 'id',
        valueName: 'productName',
        selectedOptions: []
      }]
    };
  },
  computed: {
    noCondition() {
      for (let selectItem of this.searchItems) {
        if (selectItem.selectedOptions.length > 0) {
          return false;
        }
      }
      return true;
    }
  },
  mounted() {},
  methods: {
    onSearch() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    },
    showCondition() {
      this.showPopup = true;
    },
    handlePopSelectConfirm(searchItems) {
      for (let searchItem of searchItems) {
        this.searchForm[searchItem.name] = searchItem.selectedOptions[0];
      }
      this.$refs['ListViewCpt'].initListData();
      this.showPopup = false;
    }
  }
};